// extracted by mini-css-extract-plugin
module.exports = {"nav":"_2Hpv2"};